import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { FormGroupType } from '../../../../../core/models/form-group-type';
import { RegExPattern } from '../../../../../core/models/regexp-pattern/regex-pattern';
import { RegexInputDirective } from '../../../../../shared/directives/regex-input/regex-input.directive';
import { ApplicationTemplateRequest } from '../../shared/models/application-template-form-model';
import { ApplicationTemplateFormService } from '../../shared/services/application-template-form/application-template-form.service';
import { DraggableModalWrapperComponent } from '../../../../../shared/components/modal/draggable-modal-wrapper/draggable-modal-wrapper.component';

@Component({
    selector: 'app-application-template-form-dialog',
    templateUrl: `./application-template-form-dialog.component.html`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatStepperModule,
        MatInputModule,
        MatButtonModule,
        MatFormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        RegexInputDirective,
        DraggableModalWrapperComponent,
    ],
})
export class ApplicationTemplateFormDialogComponent
    implements OnInit, OnDestroy
{
    private destroy$: Subject<void> = new Subject<void>();

    @Input() isModification: boolean = false;
    @Input() form!: FormGroup<FormGroupType<ApplicationTemplateRequest>>;

    @Output() submission = new EventEmitter<void>();
    @Output() closeDialog = new EventEmitter<void>();
    @Output() checkTemplateNameExistence = new EventEmitter<void>();

    @ViewChild('nameInput') nameInput!: ElementRef;

    regExPattern = RegExPattern;

    constructor(
        readonly applicationTemplateFormService: ApplicationTemplateFormService,
    ) {}

    ngOnInit(): void {
        this.setInitialFieldFocus();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onNextClick(stepper: MatStepper): void {
        this.checkTemplateNameExistence.emit();

        // Manually trigger the navigation to next step
        stepper.next();
    }

    onSubmissionClick(): void {
        this.submission.emit();
    }

    onCancelClick(): void {
        this.closeDialog.emit();
    }

    isOverwrite(): boolean {
        return this.form.controls.shouldOverwrite.value ?? false;
    }

    private setInitialFieldFocus(): void {
        setTimeout(() => this.nameInput.nativeElement.focus());
    }
}
